import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import DoctorsInfoCard from "./DoctorsInfoCard";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import { Grid, Typography, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import "./DoctorAppointmentsCards.scss";
import PublicIcon from "@mui/icons-material/Public";
import PinDropIcon from "@mui/icons-material/PinDrop";
import { CheckToken } from "../login/AccessToken";
import Alert from "@mui/material/Alert";
import { toast } from "react-toastify";

// Importing images for each department

import sleepMedicineIcon from "../../assets/images/icons/sleep.png";
import painManagementIcon from "../../assets/images/icons/muscle-spasm.png";
import palliativeCareIcon from "../../assets/images/icons/social-care.png";
import internalMedicineIcon from "../../assets/images/icons/take-medicines.png";
import familyMedicineIcon from "../../assets/images/icons/medical.png";
import neonatologyIcon from "../../assets/images/icons/baby.png";
import cardiothoracicSurgeryIcon from "../../assets/images/icons/heart.png";
import vascularSurgeryIcon from "../../assets/images/icons/surgery.png";
import plasticSurgeryIcon from "../../assets/images/icons/reconstructive.png";
import entIcon from "../../assets/images/icons/head.png"; // Otolaryngology (ENT)
import anesthesiologyIcon from "../../assets/images/icons/anesthesiology.png";

import geriatricsIcon from "../../assets/images/icons/geriatrics.png";
import physicalMedicineIcon from "../../assets/images/icons/medicine2.png";
import allergyImmunologyIcon from "../../assets/images/icons/allergy.png";
import infectiousDiseasesIcon from "../../assets/images/icons/coronavirus.png";
import rheumatologyIcon from "../../assets/images/icons/rheumatology.png";
import hematologyIcon from "../../assets/images/icons/blood-drop.png";
import radiologyIcon from "../../assets/images/icons/radiology.png";
import urologyIcon from "../../assets/images/icons/urology.png";
import orthopaedicsIcon from "../../assets/images/icons/trabecular.png";
import pulmonologyIcon from "../../assets/images/icons/pulmonology.png";
import emergencyMedicinesIcon from "../../assets/images/icons/medicine.png";
import nephrologyIcon from "../../assets/images/icons/nephrology.png";
import psychiatryIcon from "../../assets/images/icons/psychiatry.png";
import gynecologyIcon from "../../assets/images/icons/gynecology.png";
import dermatologyIcon from "../../assets/images/icons/dermatology.png";
import oncologyIcon from "../../assets/images/icons/oncology.png";
import neurologyIcon from "../../assets/images/icons/neuron.png";
import gastroenterologyIcon from "../../assets/images/icons/stomach.png";
import cardiologyIcon from "../../assets/images/icons/medical-checkup.png";
import endocrinologyIcon from "../../assets/images/icons/endocrinology.png";
import paediatricsIcon from "../../assets/images/icons/healthcare.png";
import ophthalmologyIcon from "../../assets/images/icons/vision-care.png";
import dentistryIcon from "../../assets/images/icons/dental-checkup.png";
import generalPracticeIcon from "../../assets/images/icons/doctors-office.png";
import hepatologyIcon from "../../assets/images/icons/hepatology.png";
import nutritionIcon from "../../assets/images/icons/nutrition.png";

const DoctorAppointmentsCards = () => {
  const history = useHistory();
  const [doctorsList, setDoctorsList] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [userData, setUserData] = useState();
  const [noDoctorsMessage, setNoDoctorsMessage] = useState("");
  const [departmentForError, setDepartmentForError] = useState("");
  const [brandingData, setBrandingData] = useState([]);
  const [timeoutId, setTimeoutId] = useState(null);

  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") || ""
  );
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQueryForDoctors, setSearchQueryForDoctors] = useState("");
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const facility_id = sessionStorage.getItem("facility_name");
  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  const navigate = (route, state) => {
    history.push(`/${route}`, state);
  };

  useEffect(() => {
    if (!sessionStorage.getItem("accessToken")) {
      history.push("/login");
    }
  }, []);

  useEffect(() => {
    getAllDepartments();
  }, []);

  useEffect(() => {
    fetchBrandingData();
  }, []);

  const fetchBrandingData = () => {
    const payload = {
      bucket_type: "tenant",
      bucket_category: "dept",
      // config_type:"departments",
      // functionality: "branding",
      // segment: "departments",
      file_key: "",
      facility: true,
      facility_id: facility_id,
    };

    axios
      .post(`${REACT_APP_BACKEND_ROUTE_URL}get_facility_branding/`, payload, {
        headers: {
          ...headers,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.status === "Success") {
          // Transform branding data into a map for easy lookup by department name
          const brandingMap = res.data.data.reduce((acc, item) => {
            acc[
              item.name.replace(".png", "")
            ] = `data:image/png;base64,${item.content}`;
            return acc;
          }, {});
          console.log("testnow", brandingMap);
          setBrandingData(brandingMap); // Save the branding map
          console.log("Branding data fetched successfully:", res.data.data);
        } else if (res?.data?.message === "No files found.") {
          toast.info("Branding information not yet provided");
        } else {
          // toast.error("Error fetching branding data");
          console.log("Error:", res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
        // toast.error("Error fetching branding data");
      });
  };

  useEffect(() => {
    if (Token()) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_logged_in_user_info/`, {
          headers: headers,
        })
        .then((res) => {
          if (res.data.status === "Success") {
            console.log("data", res.data);
            setUserData(res.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  const getAllDepartments = () => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_ROUTE_URL}get_all_medical_departments/`,
        { headers }
      )
      .then((res) => {
        setDepartments(res.data.department_list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getDoctorsByDepartment = (department) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_ROUTE_URL}get_all_doctors_based_on_department/`,
        { department },
        { headers }
      )
      .then((res) => {
        if (res.data.response_list.length === 0) {
          setSelectedDepartment(null);
          setDepartmentForError(department);
          setDoctorsList([]);
          setNoDoctorsMessage(`No doctors found in ${department}.`);
          const newTimeoutId = setTimeout(() => {
            setNoDoctorsMessage("");
          }, 5000);
          setTimeoutId(newTimeoutId);
        } else {
          setSelectedDepartment(department);
          setDoctorsList(res.data.response_list);
          setNoDoctorsMessage("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  console.log("noDoctorsMessage", noDoctorsMessage);

  const filteredDepartments = departments.filter((department) =>
    department.department.toLowerCase().includes(searchQuery.toLowerCase())
  );
  // console.log("filteredDepartments", filteredDepartments);
  const filteredDoctors = doctorsList.filter((doctor) =>
    doctor.name.toLowerCase().includes(searchQueryForDoctors.toLowerCase())
  );

  const handleViewAppointment = (doctorId) => {
    navigate("doctor/appointments", { doctorId });
  };
  // Example paths, update with actual image paths
  // Mapping department names to the imported icons
  const departmentIcons = {
    "Sleep Medicine": sleepMedicineIcon,
    "Pain Management": painManagementIcon,
    "Palliative Care": palliativeCareIcon,
    "Internal Medicine": internalMedicineIcon,
    "Family Medicine": familyMedicineIcon,
    Neonatology: neonatologyIcon,
    "Cardiothoracic Surgery": cardiothoracicSurgeryIcon,
    "Vascular Surgery": vascularSurgeryIcon,
    "Plastic Surgery": plasticSurgeryIcon,
    "Otolaryngology (ENT)": entIcon,
    Anesthesiology: anesthesiologyIcon,
    Geriatrics: geriatricsIcon,
    "Physical Medicine and Rehabilitation": physicalMedicineIcon,
    "Allergy and Immunology": allergyImmunologyIcon,
    "Infectious Diseases": infectiousDiseasesIcon,
    Rheumatology: rheumatologyIcon,
    Hematology: hematologyIcon,
    Radiology: radiologyIcon,
    Urology: urologyIcon,
    Orthopaedics: orthopaedicsIcon,
    Pulmonology: pulmonologyIcon,
    "Emergency Medicines": emergencyMedicinesIcon,
    Nephrology: nephrologyIcon,
    Psychiatry: psychiatryIcon,
    Gynecology: gynecologyIcon,
    Dermatology: dermatologyIcon,
    Oncology: oncologyIcon,
    Neurology: neurologyIcon,
    Gastroenterology: gastroenterologyIcon,
    Cardiology: cardiologyIcon,
    Endocrinology: endocrinologyIcon,
    Paediatrics: paediatricsIcon,
    Opthalmology: ophthalmologyIcon,
    Dentistry: dentistryIcon,
    "General Practice": generalPracticeIcon,
    Hepatology: hepatologyIcon,
    Nutrition: nutritionIcon,
  };

  console.log("Branding Map:", brandingData);

  return (
    <div className="col-sm-10 col-md-10 col-lg-10 centered-content">
      <h1 className="text-center-no-transform">
        {selectedDepartment
          ? `Doctors in ${selectedDepartment}`
          : "Select a Department"}
      </h1>

      <div className="contact-panel mb-50">
        {!selectedDepartment && (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4}>
                <div className="form-group">
                  <label htmlFor="searchType">City</label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <PublicIcon />
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      value={userData?.city || ""}
                      readOnly
                    />
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={4} md={4}>
                <div className="form-group">
                  <label htmlFor="searchType">Facility</label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <PinDropIcon />
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      value={userData?.facility_name || ""}
                      readOnly
                    />
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={4} md={4}>
                <div className="form-group">
                  <label htmlFor="searchType">Search</label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <SearchIcon />
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search Departments"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>
              </Grid>
            </Grid>

            <Grid container spacing={2} justifyContent="center">
              <Grid container spacing={2} justifyContent="center">
                {filteredDepartments.map((department, index) => (
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={3}
                    key={index}
                    className="flex-center"
                  >
                    {departmentForError === department.department &&
                    noDoctorsMessage ? (
                      <IconButton className="flex-column-center" color="red">
                        <Alert
                          severity="warning"
                          className="large-green-icon"
                        ></Alert>
                        <Typography
                          variant="subtitle1"
                          className="typography-margin-top"
                        >
                          {"NO DOCTOR FOUND"}
                        </Typography>
                      </IconButton>
                    ) : (
                      <IconButton
                        onClick={() =>
                          getDoctorsByDepartment(department.department)
                        }
                        className="flex-column-center"
                      >
                        {/* Check if the brandingMap has a matching image for this department */}
                        {brandingData[department.department] ? (
                          <img
                            src={brandingData[department.department]} // Use branding image if exists
                            alt={department.department}
                            style={{ width: "40px", height: "40px" }}
                          />
                        ) : departmentIcons[department.department] ? (
                          // Use default department icon if available
                          <img
                            src={departmentIcons[department.department]}
                            alt={department.department}
                            style={{ width: "40px", height: "40px" }}
                          />
                        ) : (
                          // Fallback to LocalHospitalIcon if no specific icon found
                          <LocalHospitalIcon className="large-green-icon" />
                        )}

                        <Typography
                          variant="subtitle1"
                          className="typography-margin-top"
                        >
                          {department.department}
                        </Typography>
                      </IconButton>
                    )}
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </>
        )}

        {selectedDepartment && doctorsList.length > 0 && (
          <>
            <IconButton
              onClick={() => setSelectedDepartment(null)}
              style={{ marginBottom: "20px", color: "blue" }}
            >
              <Typography variant="button">Back to Departments</Typography>
            </IconButton>
            <div className="form-group">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <SearchIcon />
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Doctors"
                  value={searchQueryForDoctors}
                  onChange={(e) => setSearchQueryForDoctors(e.target.value)}
                />
              </div>
            </div>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              className="container-margin-top"
            >
              {filteredDoctors.map((doctor, index) => (
                <Grid item xs={12} sm={12} md={6} key={index}>
                  <DoctorsInfoCard
                    doctor={doctor}
                    handleViewAppointment={handleViewAppointment}
                  />
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </div>
    </div>
  );
};

export default DoctorAppointmentsCards;
